import React from "react";

function HeroDeFi() {
  return (
    <div
      className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
      style={{
        background: "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
      }}
    >
      <div className="container">
        <div className="row align-center">
          <div className="col-xl-9 col-lg-8">
            <div className="banner-two-content">
              <h2 className="split-text-right split-text-in-right">
                DeFi Staking Platform Development
              </h2>
              <div className="info">
                <p className="fade-up-anim">
                  Unlock the full potential of DeFi with our Staking Platform
                  Development service! We specialize in building secure,
                  scalable, and user-friendly staking platforms that allow users
                  to earn rewards by locking their digital assets in a
                  decentralized environment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroDeFi;
